import { Pipe, PipeTransform } from '@angular/core';

import { ContactSummary } from '../models';

@Pipe({
  name: 'contactName'
})
export class ContactNamePipe implements PipeTransform {
  transform(id: string, contacts: ContactSummary[] = []): string | undefined {
    return contacts.find((c) => c.id === id)?.name;
  }
}
